import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Avatar } from "./ui-bits";
import { ChevronDown } from "lucide-react";
import { cn } from "../lib/utils";

export default function AssigneePicker({ users, selected, onToggle, testid, menuTestid, optionPrefix, placeholder = "Assignees", fullWidth = false }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={cn("h-8 px-2 text-sm rounded-md border border-border flex items-center justify-between hover:bg-muted transition-colors", fullWidth && "w-full")}>
          <span className="flex items-center -space-x-1">
            {selected.length === 0 && <span className="text-muted-foreground text-xs pl-1">{placeholder}</span>}
            {selected.map((id) => {
              const u = users.find((x) => x.id === id);
              return u ? <Avatar key={id} name={u.name} userId={u.id} size="sm" className="ring-2 ring-background" /> : null;
            })}
          </span>
          <ChevronDown size={14} className="text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-1" data-testid={menuTestid}>
        {users.map((u) => (
          <button type="button" key={u.id} data-testid={`${optionPrefix}-${u.id}`} onClick={() => onToggle(u.id)}
            className="w-full flex items-center gap-2 px-2 py-1.5 rounded hover:bg-muted text-sm">
            <input type="checkbox" readOnly checked={selected.includes(u.id)} className="accent-[#E31E24]" />
            <Avatar name={u.name} userId={u.id} size="sm" online={u.online} />
            <span className="truncate">{u.name}</span>
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
